/**
 * メトリクスAPI用パラメータビルダー
 *
 * 対象の指定は pharmacy_ids / pharmacist_ids の2キーのみ。
 * 「絞らない」は**キーを送らない**ことで表す。以前は本部のとき scope: 'all_company' を
 * 送っていたが、これは user の権限から back が導ける情報の再宣言であり、
 * 「全社」の定義が back 側で分裂する入口になっていた (back: metrics/scope.py)。
 */

import { MetricsSummaryRequest } from '@/features/internal/metrics/types/metrics'

/**
 * ベースとなるターゲットパラメータ
 */
interface BaseTargetParams {
  pharmacy_ids?: string[]
  pharmacist_ids?: string[]
}

/**
 * 薬剤師用のターゲットパラメータを構築
 * @param selectedPharmacistId 選択された薬剤師ID
 * @returns ターゲットパラメータ
 */
export const buildPharmacistTargetParams = (
  selectedPharmacistId: string
): BaseTargetParams => {
  // 特定薬剤師が選択されている場合
  if (selectedPharmacistId && selectedPharmacistId !== '') {
    return { pharmacist_ids: [selectedPharmacistId] }
  }

  // 全員が選択されている場合（IDが空文字）は絞らない
  return {}
}

/**
 * 薬剤師指導分析用のパラメータを構築
 * @param startDate 開始日（YYYY-MM-DD形式）
 * @param endDate 終了日（YYYY-MM-DD形式）
 * @param selectedPharmacistId 選択された薬剤師ID
 * @param includePreviousPeriod 前期間のデータを含めるか
 * @returns リクエストパラメータ
 */
export const buildPharmacistAnalyticsParams = (
  startDate: string,
  endDate: string,
  selectedPharmacistId: string,
  includePreviousPeriod = false
): MetricsSummaryRequest => {
  const targetParams = buildPharmacistTargetParams(selectedPharmacistId)

  return {
    date_range: {
      start: startDate,
      end: endDate,
    },
    include_previous_period: includePreviousPeriod,
    ...targetParams,
  }
}
